export default "__VITE_ASSET__aaJQtyLn__"